import { Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useEffect } from 'react';

/**
 * Protected Route Component
 * Redirects to 360Restoran login if user is not authenticated
 * Shows loading state while checking authentication
 * 
 * Validates: Requirements 17.2
 */
const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Redirect to 360Restoran if not authenticated
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      //window.location.href = 'https://360restoran.com/auth/cover-login';
    }
  }, [isLoading, isAuthenticated]);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  // Show loading while redirecting
  if (!isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">360Restoran'a yönlendiriliyorsunuz...</p>
        </div>
      </div>
    );
  }

  // Render child routes if authenticated
  return <Outlet />;
};

export default ProtectedRoute;
